import React from 'react';
import './FeasibilityStudy.css'; // Create a CSS file for specific styles if needed
import Header4 from '../../components/header/header4/Header4';
import ServicesHeroSection from '../../components/services_hero_section/ServicesHeroSection';
import Footer from '../../components/footer/Footer';
import backgroundimg from '../../assets/images/construction1aa.jpg';
import ServicesOverviewSection from '../../components/services_overview_section/ServicesOverviewSection';
import img_feasibility_banner from '../../assets/images/construction1aa.jpg'; // Replace with an appropriate image path
import { FaBuilding, FaChartBar, FaCogs, FaLightbulb, FaComments, FaFileAlt, FaPaperPlane, FaCertificate } from 'react-icons/fa';
import ServicesBenefitsSection from '../../components/services_benefits_section/ServicesBenefitsSection';
import ServicesOurProcessSection from '../../components/services_our_process_section/ServicesOurProcessSection';
import ActsAndRulesSection from '../../components/acts_rules_section/ActsAndRulesSection';
import DocumentChecklist from '../../components/check_list_section/CheckListSection';

export default function FeasibilityStudy() {
  const benefits = [
    {
      icon: <FaLightbulb />,
      title: 'Informed Decision-Making',
      text: 'Analyze the feasibility of your construction project with expert insights.',
    },
    {
      icon: <FaChartBar />,
      title: 'Cost Optimization',
      text: 'Identify potential savings and avoid unnecessary expenses.',
    },
    {
      icon: <FaBuilding />,
      title: 'Project Viability',
      text: 'Evaluate the technical and economic viability of your project.',
    },
    {
      icon: <FaCogs />,
      title: 'Risk Mitigation',
      text: 'Address potential risks and challenges during the planning stage.',
    },
  ];

  const steps = [
    {
      icon: <FaComments />,
      title: 'Initial Consultation',
      description: 'Understand the scope and objectives of your project.',
    },
    {
      icon: <FaFileAlt />,
      title: 'Data Collection & Analysis',
      description: 'Gather essential data and evaluate technical requirements.',
    },
    {
      icon: <FaLightbulb />,
      title: 'Feasibility Assessment',
      description: 'Analyze project feasibility, including financial and environmental factors.',
    },
    {
      icon: <FaPaperPlane />,
      title: 'Report Preparation',
      description: 'Prepare a comprehensive feasibility study report with recommendations.',
    },
    {
      icon: <FaCertificate />,
      title: 'Project Approval Support',
      description: 'Assist in obtaining approvals based on the feasibility report.',
    },
  ];

  const acts = [
    'Environmental Impact Assessment Notification',
    'Local Zoning Regulations',
    'Construction and Development Guidelines',
    'Urban and Regional Planning Acts',
  ];

  const explanation =
    'A feasibility study ensures compliance with legal, environmental, and economic standards while evaluating the overall viability of a construction project.';

  const checklistItems = [
    { name: 'Site Location Details', description: 'Provide information about the proposed construction site.' },
    { name: 'Preliminary Design Plans', description: 'Share draft plans or layouts for analysis.' },
    { name: 'Environmental Assessments', description: 'Include environmental impact studies, if available.' },
    { name: 'Cost Estimates', description: 'Provide initial cost estimates for the project.' },
  ];

  return (
    <>
      <Header4 />
      <ServicesHeroSection
        headline="Feasibility Study for Construction"
        subheading="Evaluate the viability of your construction project with expert assistance."
        ctaPrimary={{ text: 'Request Consultation', link: '/contact-us' }}
        ctaSecondary={{ text: 'Learn More', link: '/feasibility-study-for-construction' }}
        backgroundImage={backgroundimg } // Pass the background image here
      />

      <ServicesOverviewSection
        title="What is a Feasibility Study?"
        description="A feasibility study assesses the practicality, technical aspects, and financial requirements of your construction project. It is a critical step in ensuring project success."
        image={img_feasibility_banner} // Replace with a relevant image
        altText="Feasibility Study Process"
      />

      <ServicesBenefitsSection
        title="Why Conduct a Feasibility Study?"
        description="Discover the importance of feasibility studies in construction planning and project success."
        benefits={benefits}
      />

      <ActsAndRulesSection
        title="Acts and Guidelines Covered"
        subtitle="Key Regulations and Standards"
        acts={acts}
        explanation={explanation}
      />

      <ServicesOurProcessSection
        title="Our Feasibility Study Process"
        steps={steps}
      />

      <DocumentChecklist
        mainTitle="Complete Your Onboarding"
        checklistTitle="Feasibility Study Document Checklist"
        items={checklistItems}
      />

      <Footer />
    </>
  );
}
